import React, { PureComponent, Fragment } from "react";

import { PieChart, Pie, Cell } from "recharts";

import {
  Metric,
  Error,
  formatDateFromData,
  selectFormat,
} from "./../../Utils/Utils.js";

import SharedSocialLineChart from "./../../Graphs/LineGraphs/SharedSocialLineChart/SharedSocialLineChart";

const COLORS = ["#FC6D52", "#f4f4f4"];

class TwitterTweetMetrics extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: [
      {
        Metric: "Tweets",
        Value: selectFormat(
          "number",
          this.props.data.stats.tweets_total.value,
          "0,0"
        ),
      },
      {
        Metric: "Post Tweets",
        Value: selectFormat(
          "number",
          this.props.data.stats.tweets_post.value,
          "0,0"
        ),
      },
      {
        Metric: "Video Tweets",
        Value: selectFormat("number", this.props.data.stats.tweets_video.value),
      },
      {
        Metric: "Engagements per 1k",
        Value: selectFormat(
          "number",
          this.props.data.stats.engagements_per_1k.value,
          "0,0"
        ),
      },
      {
        Metric: "Retweets",
        Value: selectFormat(
          "number",
          this.props.data.stats.retweets.value,
          "0,0"
        ),
      },
      {
        Metric: "Replies",
        Value: selectFormat(
          "number",
          this.props.data.stats.replies.value,
          "0,0"
        ),
      },
      {
        Metric: "Likes",
        Value: selectFormat("number", this.props.data.stats.likes.value, "0,0"),
      },
      {
        Metric: "Engagement Paid %",
        Value: selectFormat(
          "percentage",
          this.props.data.stats.engagements.paid[0].value
        ),
      },
    ],
    opts: {
      type: "other",
    },
  });

  render() {
    const { data, project, project_id, title } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    // data.stats.engagements.paid = data.stats.engagements.paid || 0;
    data.stats.engagements.paid = [
      { value: 100 * data.stats.engagements.paid },
      { value: 100 * (1 - data.stats.engagements.paid) },
    ];

    let preparedData = formatDateFromData(
      this.props.data.graph.map((e) => ({ ...e, name: e.full_date || e.name })),
      null,
      "name"
    );

    return (
      <Fragment>
        <div key={"stats"} className="row mb-4">
          <div className="col-12 mb-3">
            <h6 className="widget__metric-label">Tweets</h6>
            <Metric {...data.stats.tweets_total} size={"md"} />
          </div>

          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Post Tweets</h6>
            <Metric {...data.stats.tweets_post} size={"sm"} />
          </div>

          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Video Tweets</h6>
            <Metric {...data.stats.tweets_video} size={"sm"} />
          </div>

          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Engagements per 1k</h6>
            <Metric {...data.stats.engagements_per_1k} size={"sm"} />
          </div>

          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Retweets</h6>
            <Metric {...data.stats.retweets} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Replies</h6>
            <Metric {...data.stats.replies} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Likes</h6>
            <Metric {...data.stats.likes} size={"sm"} />
          </div>
          <div className="col-6 col-sm-4 col-md-4 col-lg-2 mb-3">
            <h6 className="widget__metric-label">Engagement Paid %</h6>
            <PieChart height={45} width={45}>
              <Pie
                dataKey="value"
                data={data.stats.engagements.paid}
                outerRadius="100%"
                innerRadius="75%"
                startAngle={450}
                endAngle={90}
              >
                {data.stats.engagements.paid.map((entry, index) => (
                  <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="piechart-metric__xsmall"
              >
                {selectFormat(
                  "percentage",
                  data.stats.engagements.paid[0].value / 100
                )}
              </text>
            </PieChart>
          </div>
        </div>
        <SharedSocialLineChart
          ref={(el) => (this.childRef = el)}
          data={preparedData}
          insightData={data}
          project={project}
          projectId={project_id}
          title={title}
          color={"#FCD23A"}
        />
      </Fragment>
    );
  }
}

export default TwitterTweetMetrics;
